(() => {
  const protectVideo = (video) => {
    if (!(video instanceof HTMLVideoElement) || video.dataset.yinshineProtected === 'true') return;

    video.dataset.yinshineProtected = 'true';
    video.setAttribute('controlslist', 'nodownload noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');
    video.setAttribute('disableremoteplayback', '');
    video.setAttribute('draggable', 'false');
    video.addEventListener('contextmenu', (event) => event.preventDefault());
    video.addEventListener('dragstart', (event) => event.preventDefault());
  };

  const protectVideosWithin = (root) => {
    if (root instanceof HTMLVideoElement) protectVideo(root);
    root.querySelectorAll?.('video').forEach(protectVideo);
  };

  const initialize = () => {
    protectVideosWithin(document);

    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) protectVideosWithin(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
